export const apiUrl = process.env.VUE_APP_APIURL // 'http://localhost:57537/api/'
export const version = process.env.VUE_APP_VERSION
export const userTokenStorageKey = 'APP_USER_TOKEN'
export const userDataStorageKey = 'APP_USER_DATA'

// Contact address used by the "Upgrade your plan" prompts (free-tier feature).
// Current build is MRP One → mrpone@prodexis.com.
// NOTE: Prodexis builds should use 'info@prodexis.com' — switch this when a
// build-time brand flag (the same one that switches logo / primary language)
// becomes available.
export const upgradeContactEmail = 'mrpone@prodexis.com'
